module.exports = __webpack_public_path__ + "static/media/Mets_Word_Mark_Transparent.8c93deef.png";